import { DetailPage, Row } from "../../components/crud/DetailPage"
import { FkLink, ListPage } from "../../components/crud/ListPage"
import { AsyncSelect, TextareaInput } from "../../components/forms/Inputs"
import { useOptions } from "../../hooks/useOptions"
import { useTranslations } from "../../layers/Localization"

function MaterielFields({ chantier, item, set }) {
    const t = useTranslations()
    const chantierOptions = useOptions('chantiers', 'nom')
    const articleOptions = useOptions('articles', 'nom')
    return <>
        <Row>
            {chantier
                ? <AsyncSelect label={t("Article")} value={item.articleId} onChange={set('articleId')} options={articleOptions} required />
                : <AsyncSelect label={t("Chantier")} value={item.chantierId} onChange={set('chantierId')} options={chantierOptions} required />
            }
        </Row>
        <TextareaInput label={t("Commentaire")} value={item.commentaire} onChange={set('commentaire')} />
    </>
}

function MaterielFieldsChantier(props) {
    return <MaterielFields {...props} chantier />
}

export function MaterielList({ chantier, ...props }) {
    const t = useTranslations()
    return <ListPage model="materiel" title={t("Matériel")} columns={{
        ...(chantier
            ? { [t("Article")]: { sort: 'article', value: item => <FkLink>{item.article?.nom}</FkLink> } }
            : { [t("Chantier")]: { sort: 'chantier', value: item => <FkLink>{item.chantier?.nom}</FkLink> } }
        ),
        [t('Commentaire')]: 'commentaire',
    }} join={chantier
        ? { 'article': 'nom' }
        : { 'chantier': 'nom' }
    } {...props} />
}

export function MaterielDetail({ chantier, ...props }) {
    const t = useTranslations()
    return <DetailPage model="materiel" title={t("Matériel")} Fields={chantier ? MaterielFieldsChantier : MaterielFields} {...props} />
}
